module.exports = __webpack_public_path__ + "img/Ilustracion No tiene Clases.dc1a5435.svg";